let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1kFiT")).then(() => parcelRequire('dZ1X7'));